import { FunctionComponent } from 'react';
import { useMediaGalleryLightBoxContext } from '../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { MediaGalleryActionBar } from './MediaGalleryActionBar';

interface MediaGalleryActionBarProps {
  opened: boolean;
  onClose: () => void;
}

export const MediaGalleryActionBarWithData: FunctionComponent<MediaGalleryActionBarProps> = ({
  onClose,
  opened,
}) => {
  const { currentSlideIndex, mediaItems } = useMediaGalleryLightBoxContext();

  if (!mediaItems || mediaItems.length === 0) return null;

  return (
    <MediaGalleryActionBar
      onClose={onClose}
      opened={opened}
      searchByImageButton={mediaItems[currentSlideIndex].searchByImageButton}
    />
  );
};
